module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/large-self-10x25-250x2000.svg";